import { useEffect, useRef, useState } from "react"

// Tracks whether the observed element has been scrolled above the viewport.
// Used to reveal sticky CTAs only after their inline counterpart is out of sight.
const useElementOutOfView = <T extends HTMLElement>() => {
  const targetRef = useRef<T | null>(null)
  const [outOfView, setOutOfView] = useState(false)

  useEffect(() => {
    const target = targetRef.current
    if (!target || typeof IntersectionObserver === "undefined") return

    const observer = new IntersectionObserver(([entry]) => {
      setOutOfView(!entry.isIntersecting && entry.boundingClientRect.top < 0)
    })
    observer.observe(target)

    return () => observer.disconnect()
  }, [])

  return { targetRef, outOfView }
}

export default useElementOutOfView
